import React from "react";
import "./NotFound.css";
import { Link } from "react-router-dom";
import SEO from "../../Components/SEO/SEO";
import { Compass, ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <div className="NotFound fade-in">
      <SEO title="Страница не найдена — Шахризада" />
      <div className="NotFound--Inner">
        <div className="NotFound--Icon">
          <Compass size={42} />
        </div>
        <span className="section-eyebrow">Ошибка 404</span>
        <h1 className="NotFound--Title">Страница не найдена</h1>
        <p className="NotFound--Text">
          Похоже, эта страница потерялась среди ароматов восточного базара.
          Давайте вернёмся в меню.
        </p>
        <Link to="/" className="accent--button">
          <ArrowLeft size={16} /> На главную
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
